import styled from 'styled-components';

const StyledNumbersRowDouble = styled.div`
  position: relative;
  width: auto;
  display: flex;
  align-items: stretch;
  justify-content: center;
  margin-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  padding: 0 64px;
  height: 100%;
  >div:nth-child(1){
    margin-right: 135px;
  }
  @media screen and (max-width: 1439px){
    padding: 0 40px;
    >div:nth-child(1){
      margin-right: 105px;
    }
  }
  @media screen and (max-width: 1023px){
    margin-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    >div:nth-child(1){
      margin-right: 75px;
    }
  }
  @media screen and (max-width: 767px){
    padding: 0;
    margin-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    flex-direction: column;
    >div:nth-child(1){
      margin-right: 0;
      height: 210px;
      margin-bottom: 80px;
    }
  }
`;

export {
  StyledNumbersRowDouble,
};

